"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _events = require("events");

var _stringify = _interopRequireDefault(require("./stringify"));

var _extractError = _interopRequireDefault(require("./extract-error"));

var _dalError = require("./dal-error");

var REQUEST_ID_HEADER_NAME = 'x-cpinternalrequestid';

var AbstractClient =
/*#__PURE__*/
function (_EventEmitter) {
  (0, _inherits2["default"])(AbstractClient, _EventEmitter);

  function AbstractClient(credentials) {
    var _this;

    var apiBase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'https://api.classpass.com';
    (0, _classCallCheck2["default"])(this, AbstractClient);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(AbstractClient).call(this));

    if (!credentials) {
      throw new Error('No credentials provided');
    }

    _this.credentials = credentials;
    _this.apiBase = apiBase;
    _this.headers = {};
    return _this;
  }

  (0, _createClass2["default"])(AbstractClient, [{
    key: "setToken",
    value: function setToken(token) {
      this.credentials.token = token;
    }
  }, {
    key: "getToken",
    value: function getToken() {
      return this.credentials.token;
    }
  }, {
    key: "getAuthorizationHeaderName",
    value: function getAuthorizationHeaderName() {
      return this.credentials.header || 'CP-Authorization';
    }
  }, {
    key: "setHeader",
    value: function setHeader(key, value) {
      this.headers[key] = value;
    }
  }, {
    key: "request",
    value: function request(method, url, params, overrides, name) {
      var _this2 = this;

      var startAt = Date.now();
      this.emit('request', {
        name: name,
        method: method,
        url: url,
        params: params,
        overrides: overrides,
        startAt: startAt
      });
      return this.sendRequest(method, url, params, overrides).then(function (resp) {
        var endAt = Date.now();
        var contentType = resp.headers && resp.headers['content-type'] || '';
        var isEmptyBody = !(resp.body || '').trim();
        var isJsonReponse = contentType.indexOf('application/json') !== -1;
        var status = parseInt(resp.status, 10);
        var is2xxResponse = status >= 200 && status < 300;
        var data;

        if (resp.wasNetworkTimeout) {
          throw new _dalError.DALNetworkTimeoutError('api request timed out', '', {
            method: method,
            endpoint: name,
            path: url
          });
        }

        if (isJsonReponse && !isEmptyBody) {
          try {
            data = JSON.parse(resp.body);
          } catch (err) {
            throw new _dalError.DALJsonParseError('could not parse response as JSON', '', {
              code: 1,
              method: method,
              endpoint: name,
              path: url,
              httpStatus: resp.status,
              requestId: resp.headers[REQUEST_ID_HEADER_NAME]
            });
          }
        }

        if (!is2xxResponse) {
          if (data) {
            var error = (0, _extractError["default"])(data);

            if (error) {
              var ErrorClass = (0, _dalError.statusToErrorClass)(resp.status);
              throw new ErrorClass(error.message, error.details, {
                code: error.code,
                method: method,
                endpoint: name,
                path: url,
                httpStatus: resp.status,
                requestId: resp.headers[REQUEST_ID_HEADER_NAME]
              });
            } else {
              throw new _dalError.DALNoErrorError("got ".concat(resp.status, "-status JSON response from API without error"), '', {
                code: 3,
                method: method,
                endpoint: name,
                path: url,
                httpStatus: resp.status,
                requestId: resp.headers[REQUEST_ID_HEADER_NAME]
              });
            }
          } else {
            var _ErrorClass = (0, _dalError.statusToErrorClass)(resp.status, _dalError.DALNoDataError);

            throw new _ErrorClass("got ".concat(resp.status, "-status ").concat(contentType, " response from API without data"), '', {
              code: resp.status || 2,
              method: method,
              endpoint: name,
              path: url,
              httpStatus: resp.status,
              requestId: resp.headers[REQUEST_ID_HEADER_NAME]
            });
          }
        }

        _this2.emit('success', {
          name: name,
          method: method,
          url: url,
          params: params,
          overrides: overrides,
          size: (resp.body || '').length,
          httpStatus: resp.status,
          requestId: resp.headers && resp.headers[REQUEST_ID_HEADER_NAME],
          startAt: startAt,
          endAt: endAt,
          duration: endAt - startAt
        });

        return data;
      })["catch"](function (err) {
        var endAt = Date.now();
        var error;

        if (err instanceof _dalError.DALError) {
          error = err;
        } else {
          error = new Error("DAL transport error: ".concat(err.message || err));
          error.stack = err.stack;
        }

        _this2.emit('failure', {
          name: name,
          method: method,
          url: url,
          params: params,
          overrides: overrides,
          httpStatus: err.httpStatus || 0,
          code: error.code || 0,
          startAt: startAt,
          endAt: endAt,
          duration: endAt - startAt,
          requestId: err.requestId
        });

        throw error;
      });
    }
  }, {
    key: "get",
    value: function get(url, params, overrides, name) {
      return this.request('GET', url + (params ? "?".concat((0, _stringify["default"])(params, !!(overrides && overrides.brackets))) : ''), null, overrides, name);
    }
  }, {
    key: "post",
    value: function post(url, params, overrides, name) {
      return this.request('POST', url, params, overrides, name);
    }
  }, {
    key: "put",
    value: function put(url, params, overrides, name) {
      return this.request('PUT', url, params, overrides, name);
    }
  }, {
    key: "delete",
    value: function _delete(url, params, overrides, name) {
      return this.request('DELETE', url, params, overrides, name);
    }
  }, {
    key: "patch",
    value: function patch(url, params, overrides, name) {
      return this.request('PATCH', url, params, overrides, name);
    }
  }]);
  return AbstractClient;
}(_events.EventEmitter);

exports["default"] = AbstractClient;